export function formatDate(inputDate) {
  if (!inputDate) {
    return '';
  }
  const date = new Date(inputDate);

  // Extract components
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear();

  // Convert to 12-hour time format
  const amPm = hours >= 12 ? 'pm' : 'am';
  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;

  // Build the formatted string
  const formattedDate = `${formattedHours}:${minutes
    .toString()
    .padStart(2, '0')} ${amPm}, ${day} ${month} ${year}`;

  return formattedDate;
}

export function getTransformedScenariosForDex(payload) {
  let dexData = [];
  if (payload?.data?.execution_list_results) {
    dexData = payload?.data?.execution_list_results.map((events, index) => {
      const row = {};

      let failedCount = 0;
      let passedCount = 0;
      let queuedCount = 0;

      events?.execution_entries_results?.forEach((d) => {
        if (d?.result === 'passed') {
          passedCount += 1;
        }
        if (d?.result === 'failed') {
          failedCount += 1;
        }

        if (d?.result === 'queued') {
          queuedCount += 1;
        }
      });
      row.scenarioIndex = index;
      row.type = 'scenario';
      row.task = payload?.data?.task_id;
      row.name = events.name;
      row.status = events.result;
      row.created_at = events.start_time;
      row.link = events.link;
      row.failed = failedCount;
      row.passed = passedCount;
      row.queued = queuedCount;
      row.description = getDescription(events?.start_time, events?.end_time);

      return row;
    });
  }

  return dexData;
}

function getDescription(start, end) {
  let desc = '';
  if (start) {
    desc = `Ran from ${formatDate(start)}`;
  }

  if (end && start) {
    desc += `  to ${formatDate(end)}`;
  }

  return desc;
}
